import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2, Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Rewards({ event, slug, refresh }) {
  const [rewards, setRewards] = useState(null);
  const [f, setF] = useState({ name: "", min_xp: 0, max_xp: 199, tier: "bronze" });
  const load = () => api.get(`/events/${slug}/rewards`).then((r) => setRewards(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [slug]);
  const add = async () => {
    if (!f.name.trim()) { toast.error("Reward name required"); return; }
    await api.post(`/events/${slug}/rewards`, { ...f, min_xp: Number(f.min_xp), max_xp: Number(f.max_xp) });
    setF({ name: "", min_xp: 0, max_xp: 199, tier: "bronze" }); load();
  };
  const del = async (id) => { await api.delete(`/events/${slug}/rewards/${id}`); load(); };
  const toggleAch = async (v) => { await api.put(`/events/${slug}`, { achievements_enabled: v }); refresh(); };
  if (!rewards) return <Loader2 className="w-6 h-6 animate-spin text-primary" />;
  const tierColor = { participation: "#A3A3A3", bronze: "#CD7F32", silver: "#C0C0C0", gold: "#FFCC00" };
  return (
    <div className="space-y-6">
      <div><h1 className="font-head font-black text-2xl">Reward Vault</h1><p className="text-muted-foreground text-sm">Configure Cash tiers players unlock at your event.</p></div>

      <div className="brut p-4 flex items-center justify-between">
        <div><p className="font-bold">Achievements</p><p className="text-xs text-muted-foreground">Auto-award badges like First Challenge, 1,000 Cash Club and more.</p></div>
        <Switch checked={event.achievements_enabled} onCheckedChange={toggleAch} data-testid="ach-toggle" />
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {rewards.map((r) => (
          <div key={r.reward_id} className="brut p-4 flex items-center gap-3" data-testid={`reward-row-${r.reward_id}`}>
            <div className="w-10 h-10 rounded-lg grid place-items-center border-2 border-neutral-300" style={{ background: tierColor[r.tier] || "#888" }}><Gift className="w-5 h-5 text-black" /></div>
            <div className="flex-1"><p className="font-bold">{r.name}</p><p className="text-xs text-muted-foreground font-mono-num">{r.min_xp}–{r.max_xp === 999999 ? "∞" : r.max_xp} Cash · {r.tier}</p></div>
            <Button size="icon" variant="ghost" className="text-primary" onClick={() => del(r.reward_id)}><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>

      <div className="brut p-5">
        <h2 className="font-head font-bold mb-3">Add reward tier</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          <div><Label className="mb-1 block">Name</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="e.g. Gold Reward" data-testid="reward-name" /></div>
          <div><Label className="mb-1 block">Tier</Label>
            <Select value={f.tier} onValueChange={(v) => setF({ ...f, tier: v })}><SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="participation">Participation</SelectItem><SelectItem value="bronze">Bronze</SelectItem><SelectItem value="silver">Silver</SelectItem><SelectItem value="gold">Gold</SelectItem></SelectContent>
            </Select>
          </div>
          <div><Label className="mb-1 block">Min Cash</Label><Input type="number" value={f.min_xp} onChange={(e) => setF({ ...f, min_xp: e.target.value })} /></div>
          <div><Label className="mb-1 block">Max Cash</Label><Input type="number" value={f.max_xp} onChange={(e) => setF({ ...f, max_xp: e.target.value })} /></div>
        </div>
        <Button className="rounded-full font-bold mt-4" onClick={add} data-testid="add-reward"><Plus className="w-4 h-4 mr-1" />Add Reward</Button>
      </div>
    </div>
  );
}
